import ProductSuggestion from "./ProductSuggestion";

import "./ProductSuggestion.scss";

export * from "./ProductSuggestion.types";

export { ProductSuggestion };
